export const FETCH_ALL_PRODUCT_LOCATION_SUCCEEDED = 'FETCH_ALL_PRODUCT_LOCATION_SUCCEEDED';
export const FETCH_ALL_STORAGE_DESTINATION_SUCCEEDED = 'FETCH_ALL_STORAGE_DESTINATION_SUCCEEDED';
export const GO_TO_DESTINATION = 'GO_TO_DESTINATION';
export const FILTER_FROM_STORAGE = 'FILTER_FROM_STORAGE';
export const FETCH_ALL_LOCATION_LAST_TRACK_SUCCEEDED = 'FETCH_ALL_LOCATION_LAST_TRACK_SUCCEEDED';
